import { StaticImageData } from 'next/image'

import brandLogo118118 from '@images/brand-logo-118-118-money.png'
import brandLogoBarclaycard from '@images/brand-logo-barclaycard.png'
import brandLogoHSBC from '@images/brand-logo-hsbc.png'
import brandLogoLloyds from '@images/brand-logo-lloyds.png'
import brandLogoMarksAndSpencer from '@images/brand-logo-m&s-bank.png'
import brandLogoMBNA from '@images/brand-logo-mbna.png'
import brandLogoSantander from '@images/brand-logo-santander.png'
import brandLogoTescoBank from '@images/brand-logo-tesco-bank.png'
import brandLogoVanquis from '@images/brand-logo-vanquis.png'
import brandLogoVirginMoney from '@images/brand-logo-virgin-money.png'
import brandLogoZopa from '@images/brand-logo-zopa.png'

type ProvidersListTypes = { altText: string; src: StaticImageData }

export const providersList: ProvidersListTypes[] = [
    {
        altText: 'Tesco Bank',
        src: brandLogoTescoBank,
    },

    {
        altText: 'Santander',
        src: brandLogoSantander,
    },

    {
        altText: '118 118 Money',
        src: brandLogo118118,
    },

    {
        altText: 'Barclaycard',
        src: brandLogoBarclaycard,
    },

    {
        altText: 'HSBC',
        src: brandLogoHSBC,
    },

    {
        altText: 'MBNA',
        src: brandLogoMBNA,
    },

    {
        altText: 'Virgin Money',
        src: brandLogoVirginMoney,
    },

    {
        altText: 'Lloyds Bank',
        src: brandLogoLloyds,
    },

    {
        altText: 'M&S',
        src: brandLogoMarksAndSpencer,
    },

    {
        altText: 'Zopa',
        src: brandLogoZopa,
    },

    { altText: 'Vanquis', src: brandLogoVanquis },
]
